export default class PaymentLetter {
    public readonly key: string;
    public readonly location: string;

    constructor({ key, location }: { key: string; location: string }) {
        this.key = key;
        this.location = location;
    }
}
